/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditorialReviewerUser } from '../../models/editorial-reviewer-user';

export interface GetEditorialReviewers$Params {
}

export function getEditorialReviewers(http: HttpClient, rootUrl: string, params?: GetEditorialReviewers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EditorialReviewerUser>>> {
  const rb = new RequestBuilder(rootUrl, getEditorialReviewers.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EditorialReviewerUser>>;
    })
  );
}

getEditorialReviewers.PATH = '/api/editorial/reviewers';
